export default __webpack_public_path__ + "static/media/pencil-green.af51010f.svg";